import classNames from 'classnames'
import { Stat } from './Stat'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { StatData, StatsProps } from './types'

export const Stats: ShopifySectionComponent<StatsProps> = ({
  data = { stats: [] },
}) => (
  <div
    className={classNames(
      'flex flex-col items-center md:flex-row justify-evenly wrapper wrapper--size-sm',
    )}
  >
    {data.stats.map((stat: StatData, idx: number) => (
      <Stat
        key={idx}
        {...stat}
        className="flex flex-col items-center md:items-start gap-y-2"
      />
    ))}
  </div>
)
